import { render } from "./company-car-order-process-component.vue?vue&type=template&id=183df5f5"
import script from "./company-car-order-process-component.vue?vue&type=script&lang=js"
export * from "./company-car-order-process-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__